import React, {forwardRef} from "react";
import { Row, Col } from "react-bootstrap";
import DocumentCard from "../../Documents/DocumentCard";
import { setGlobalErrorStatus } from "../../StatusHandling";
import { ERROR_MESSAGES } from "../../../Utils/constants";
import {useDispatch, useSelector} from "react-redux";


export const MainContent = forwardRef((data, ref) => {
  const dispatch = useDispatch();
  const commonFormatsData = data.data.commonFormatsData;
  const errorHandle = function () {
    setGlobalErrorStatus({
      dispatch: dispatch,
      popupData: {
        visible: true,
        title: ERROR_MESSAGES.GENERAL_ERROR.title,
        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
        showContactHelp: true,
      },
      redirect: {
        redirect: false,
        redirectFirst: false,
        path: "",
        data: {},
      },
    });
  };
  
  /**
   * Render cards for a node (level 1 / 2 / 3)
   * Sequence on the page stays:
   * title -> content -> cardsPrologue -> cards
   */
  const renderCards = (cardsArr) => {
    if (!cardsArr || cardsArr.length === 0) {
      return null;
    }
    
    return (
      <Row className="g-3 mt-2">
        {cardsArr.map((groupId, idx) => (
          <Col
            key={`cf-doc-card-${groupId}-${idx}`}
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            xxl={4}
          >
            <DocumentCard groupId={groupId} errorHandle={errorHandle} />
          </Col>
        ))}
      </Row>
    );
  };
  
  const renderContent = (item, index, level, parentKey = "", lastLevel1Item) => {
    const key = `${parentKey}level${level}-${index}`;
    
    if (level === 1 && !item.title && item.children) {
      return (
        <React.Fragment key={key}>
          {item.children.map((child, childIndex) =>
            renderContent(child, childIndex, 2, key + "-", lastLevel1Item)
          )}
          {index!==lastLevel1Item-1 ? <div className="mt-5 mb-5 common-formats-border-bottom-dashed"></div> : null}
        </React.Fragment>
      );
    }
    
    return (
      <div key={key}>
        <div
          ref={(el) => (ref.current[key] = el)}
          className="mb-5"
        >
          {item.title && (
            level===1 ? <h2 className={`mb-3 common-formats-header header2`} id={item.id}>{item.mainContentTitle ?? item.title}</h2> :
              level===2 ? <h3 className={`mb-3 common-formats-header header3`} id={item.id}>{item.mainContentTitle ?? item.title}</h3> :
                <h4 className={`mb-3 common-formats-header header4`} id={item.id}>{item.mainContentTitle ?? item.title}</h4>
          )}
          
          {item.content && <div className="mt-3 mb-3 body common-formats-main-content-text" >{item.content}</div>}
          
          {item.cardsPrologue && (
            <div className="mt-1 mb-3 body">{item.cardsPrologue}</div>
          )}
          
          {/* NEW: render cards if present */}
          {renderCards(item.cards)}
        </div>
        
        {item.children &&
          item.children.map((child, childIndex) =>
            renderContent(child, childIndex, level + 1, key + "-", lastLevel1Item)
          )}
        
        {level === 1 && index!==lastLevel1Item-1 && item.title ? (
          <div className="mt-5 mb-5 common-formats-border-bottom-dashed"></div>
        ) : null}
      </div>
    );
  };
  
  return <div className={`common-formats-main-content`}>{commonFormatsData.map((item, index) => renderContent(item, index, 1, "", commonFormatsData.length))}</div>;
});
//
// export const MainContent = ({ data, ref }) => {
//   const dispatch = useDispatch();
//
//   const errorHandle = function () {
//     setGlobalErrorStatus({
//       dispatch: dispatch,
//       popupData: {
//         visible: true,
//         title: ERROR_MESSAGES.GENERAL_ERROR.title,
//         msg: ERROR_MESSAGES.GENERAL_ERROR.message,
//         showContactHelp: true,
//       },
//       redirect: {
//         redirect: false,
//         redirectFirst: false,
//         path: "",
//         data: {},
//       },
//     });
//   };
//
//   /**
//    * Render cards for a node (level 1 / 2 / 3)
//    * Sequence on the page stays:
//    * title -> content -> cardsPrologue -> cards
//    */
//   const renderCards = (cardsArr) => {
//     if (!cardsArr || cardsArr.length === 0) {
//       return null;
//     }
//
//     return (
//       <Row className="g-3 mt-2">
//         {cardsArr.map((groupId, idx) => (
//           <Col
//             key={`cf-doc-card-${groupId}-${idx}`}
//             xs={12}
//             sm={12}
//             md={6}
//             lg={6}
//             xl={6}
//             xxl={4}
//           >
//             <DocumentCard groupId={groupId} errorHandle={errorHandle} />
//           </Col>
//         ))}
//       </Row>
//     );
//   };
//
//   const renderContent = (item, index, level, parentKey = "", lastLevel1Item) => {
//     const key = `${parentKey}level${level}-${index}`;
//
//     if (level === 1 && !item.title && item.children) {
//       return (
//         <React.Fragment key={key}>
//           {item.children.map((child, childIndex) =>
//             renderContent(child, childIndex, 2, key + "-", lastLevel1Item)
//           )}
//           {index!==lastLevel1Item-1 ? <div className="mt-5 mb-5 common-formats-border-bottom-dashed"></div> : null}
//         </React.Fragment>
//       );
//     }
//
//     return (
//       <div key={key}>
//         <div
//           ref={(el) => (ref.current[key] = el)}
//           className="mb-5"
//         >
//           {item.title && (
//             level===1 ? <h2 className={`mb-3 common-formats-header header2`}>{item.mainContentTitle ?? item.title}</h2> :
//               level===2 ? <h3 className={`mb-3 common-formats-header header3`}>{item.mainContentTitle ?? item.title}</h3> :
//                 <h4 className={`mb-3 common-formats-header header4`}>{item.mainContentTitle ?? item.title}</h4>
//           )}
//
//           {item.content && <p className="mt-3 mb-3 body ">{item.content}</p>}
//
//           {item.cardsPrologue && (
//             <p className="mt-1 mb-3 body">{item.cardsPrologue}</p>
//           )}
//
//           {/* NEW: render cards if present */}
//           {renderCards(item.cards)}
//         </div>
//
//         {item.children &&
//           item.children.map((child, childIndex) =>
//             renderContent(child, childIndex, level + 1, key + "-", lastLevel1Item)
//           )}
//
//         {level === 1 && index!==lastLevel1Item-1 && item.title ? (
//           <div className="mt-5 mb-5 common-formats-border-bottom-dashed"></div>
//         ) : null}
//       </div>
//     );
//   };
//
//   return <div>{data.commonFormatsData.map((item, index) => renderContent(item, index, 1, "", data.commonFormatsData.length))}</div>;
// };
